import { FC } from 'react'
import cx from 'classnames'
import { ImageProps } from 'next/image'

import { IconProps } from '../Icon'

import * as SC from './styled'

export type UrpsFactProps = {
  className?: string
  image?: ImageProps
  icon?: IconProps
  value: string
  text: string
}

const UrpsFact: FC<UrpsFactProps> = ({
  className,
  image,
  icon,
  value,
  text,
}) => {
  return (
    <SC.UrpsFact className={cx('UrpsFact', className)}>
      {image && <SC.Image {...image} />}
      {icon && <SC.IconStyled {...icon} />}
      <SC.Value>{value}</SC.Value>
      <SC.Text>{text}</SC.Text>
    </SC.UrpsFact>
  )
}

export default UrpsFact
